var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Flag = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 832 1024", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M817.94 149.5a32 32 0 0 0-29.82-3.21c-151.4 60.56-238.34 60.82-357.81 1.09C359.25 111.85 299.32 96 236 96c-62.36 0-128.94 15.51-215.88 50.29A32 32 0 0 0 0 176v816a32 32 0 0 0 64 0V197.88c139.19-52.62 223.62-50.29 337.69 6.74C472.75 240.15 532.68 256 596 256c51.44 0 105.75-10.56 172-33.77v411.89c-139.19 52.62-223.62 50.29-337.69-6.74-55.7-27.85-104.33-43.43-153-49-50.23-5.77-101-1.08-159.82 14.75a32 32 0 0 0 16.64 61.8c98.63-26.56 171.16-18.5 267.6 29.72C472.75 720.15 532.68 736 596 736c62.36 0 128.94-15.51 215.88-50.29A32 32 0 0 0 832 656V176a32 32 0 0 0-14.06-26.5zM32 96a32 32 0 0 0 32-32V32a32 32 0 0 0-64 0v32a32 32 0 0 0 32 32z" }))))); };
export default Flag;
//# sourceMappingURL=Flag.js.map